import React from "react";
import { Link } from "react-router-dom";
import { akilItemPrimary, akilItemSecondary } from "../../lib/aiListDisplay";

/** Liste satırı — müvekkil adı tıklanabilir link. */
export function AkilListRow({ item, className = "" }) {
    const href = item?.href;
    const primary = akilItemPrimary(item);
    const secondary = akilItemSecondary(item);

    return (
        <li
            className={`flex justify-between gap-3 rounded-lg border border-white/10 bg-white/[0.03] px-3 py-2 text-sm ${className}`}
        >
            {href ? (
                <Link to={href} className="text-slate-200 truncate hover:text-[#D4AF37] hover:underline">
                    {primary}
                </Link>
            ) : (
                <span className="text-slate-200 truncate">{primary}</span>
            )}
            <span className="text-slate-500 text-xs shrink-0">{secondary}</span>
        </li>
    );
}

export function AkilDataList({ items, max = 20 }) {
    if (!items?.length) return null;
    return (
        <ul className="mt-3 space-y-2 border-t border-white/10 pt-3">
            {items.slice(0, max).map((it, i) => (
                <AkilListRow key={it.id || it.href || i} item={it} />
            ))}
        </ul>
    );
}
